<template>
	<!-- 沙雕竟然觉得不弹性布局更好 1 -->
	<!-- <div _flex="~ col" _overflow="hidden" :style="{ height: 'calc(100vh - 100px)' }"> -->
	<div _flex="~ col" _overflow="hidden">
		<div _bg="white" _p="l-25px y-15px r-80px">
			<div
				v-if="isNotAllowBack == false"
				_flex="~ items-center"
				_text="16px"
				_cursor="pointer"
				_hover="text-color-[#ff5e2a]"
				@click="$router.go(-1)"
			>
				<i class="el-icon-arrow-left" _m="r-5px" style="font-weight: 1000;"></i>返回
			</div>
			<div _flex="~ items-center justify-between" _m="t-30px">
				<div _flex="~ items-center">
					<span _text="[#272727] 18px" style="font-weight: 600;" _m="r-20px">{{ info?.class_name }}</span>
					<span _text="[#3E793D]" _flex="~ items-center justify-center" _bg="[#F3FFF4]" _w="78px" _h="32px">{{
						info?.class_state
					}}</span>
				</div>
				<div _flex="~ items-center">
					<span
						_flex="~ items-center"
						:style="{ marginRight: index === 0 && info?.class_grade_teachers?.length >= 1 ? '15px' : 0 }"
						v-for="(item, index) in info?.class_grade_teachers"
						:key="index"
					>
						<svg
							class="icon"
							aria-hidden="true"
							style="width: 20px; height: 20px; outline: none; box-shadow: none; margin-right: 5px;"
						>
							<use v-if="item?.subject?.name === '音乐'" xlink:href="#icon-music2" style="color: #0681c5;"></use>
							<use v-if="item?.subject?.name === '美术'" xlink:href="#icon-arts" style="color: #00ad6b;"></use>
						</svg>
						{{ item?.teacher?.account?.realname }}
					</span>
				</div>
			</div>
			<div _text="[#8C8C8C]" _m="y-15px" _flex="~ justify-between" style="min-width: 750px;">
				<div _flex="~ items-center">
					<span _m="r-20px">班级识别码：&nbsp;{{ info?.id_code }}</span>
					<span>人数：&nbsp;{{ info?.students_count }}人</span>
				</div>
				<div _flex="~ items-center">
					<span _m="r-10px">学校：&nbsp;{{ info?.school_name }}&nbsp;&nbsp;|</span>
					<span _m="r-10px"
						>辖区：&nbsp;{{
							info?.school?.district_division?.l1_name +
							info.school?.district_division?.l2_name +
							(info?.school?.district_division?.l3_name || '')
						}}&nbsp;&nbsp;|</span
					>
					<span>入学年份：&nbsp;{{ info?.enroll_year }}</span>
				</div>
			</div>
			<el-divider _m="y-25px" />
			<div _text="20px [#FF5E2A]" style="font-weight: 600;">学生管理</div>
		</div>
		<!-- 沙雕竟然觉得不弹性布局更好 2 -->
		<!-- <div _flex="~ col 1" _bg="white" _m="t-20px" _p="l-25px y-15px r-80px"> -->
		<div _flex="~ col" _bg="white" _m="t-20px" _p="l-25px y-15px r-80px">
			<el-form :inline="true" ref="search" :model="search">
				<div _flex="~ justify-between">
					<div>
						<el-form-item prop="name">
							<InputTopTip v-model="search.name" placeholder="学生姓名">
								<el-input
									v-model="search.name"
									class="width-264"
									@keyup.enter.native="refreshDataList"
									placeholder=""
									size="small"
								></el-input>
							</InputTopTip>
						</el-form-item>
						<el-form-item prop="fu_number_in_class">
							<InputTopTip v-model="search.fu_number_in_class" placeholder="班内序号">
								<el-input
									v-model="search.fu_number_in_class"
									class="width-264"
									@keyup.enter.native="refreshDataList"
									placeholder=""
									size="small"
								></el-input>
							</InputTopTip>
						</el-form-item>
						<el-form-item prop="fb_state">
							<InputTopTip v-model="search.fb_state" placeholder="学生状态">
								<el-select
									ref="SearchClass"
									style="width: 120px;"
									v-model="search.fb_state"
									placeholder=""
									size="small"
									@change="
										() => {
											refreshDataList()
										}
									"
								>
									<el-option
										v-for="item in studentStatus"
										:key="item.val"
										:label="item.name"
										:value="item.val"
									></el-option>
								</el-select>
							</InputTopTip>
						</el-form-item>
					</div>
					<div>
						<el-form-item class="form-reset">
							<el-button
								type="primary"
								@click="refreshDataList()"
								size="small"
								class="action-btn"
								style="width: 70px; margin-right: 15px;"
								>搜索</el-button
							>
							<el-button @click="resetList('search')" size="small" style="width: 70px;">重置</el-button>
						</el-form-item>
					</div>
				</div>
			</el-form>
			<div>
				<el-button
					type="primary"
					size="small"
					icon="el-icon-plus"
					_m="!b-20px"
					@click=";(modalTitle = '新建'), (newVisible = true)"
					v-permission="'SP22101'"
					>新建</el-button
				>
				<el-button
					size="small"
					icon="el-icon-download"
					style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
					@click="$refs.importDialog.dialogVisible = true"
					v-permission="'SP22102'"
					>批量创建</el-button
				>
				<el-button
					size="small"
					icon="el-icon-upload2"
					style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
					@click="exportExcel('students', `${info?.school_name}-${info?.class_name}-学生数据`)"
					v-if="multipleSelection.length > 0 && $permissions(['SP22103'])"
					>导出</el-button
				>
			</div>
			<!-- 沙雕竟然觉得不弹性布局更好 3 -->
			<!-- height="150" -->
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				width="100%"
				@selection-change="handleSelectionChange"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
			>
				<el-table-column type="selection" width="60" align="center" />
				<el-table-column align="left" label="学生名字" prop="account.realname" />
				<el-table-column align="left" label="性别" prop="account.sex" :formatter="music_typeFormat" />
				<el-table-column align="left" :label="'班内序号'" prop="number_in_class" />
				<el-table-column align="left" label="学籍号" prop="account.serial" />
				<el-table-column align="center" label="微信授权">
					<template slot-scope="scope">
						<svg
							class="icon"
							v-if="scope.row.account != null"
							aria-hidden="true"
							style="width: 23px; height: 23px; outline: none; box-shadow: none;"
						>
							<use v-if="scope.row.account.openid === null" xlink:href="#icon-wechartstate"></use>
							<use v-else xlink:href="#icon-wechartstate2"></use>
						</svg>
						<svg
							class="icon"
							v-else
							aria-hidden="true"
							style="width: 23px; height: 23px; outline: none; box-shadow: none;"
						>
							<use xlink:href="#icon-wechartstate"></use>
						</svg>
					</template>
				</el-table-column>
				<el-table-column align="left" label="学生状态" prop="student_state"></el-table-column>
				<el-table-column
					align="center"
					label="操作"
					class-name="opscol"
					width="230"
					v-if="$permissions(['SP22104', 'SP22105', 'SP22106', 'SP22107', 'SP22108'])"
				>
					<template v-slot:default="slot">
						<div class="table-mgn2" _flex="~ !justify-center">
							<div
								style="color: #ff7143;"
								@click="
									$router.push({
										name: 'classstudent',
										query: { id: slot.row.uid }
									})
								"
								v-permission="'SP22104'"
							>
								<el-tooltip content="查看" placement="bottom" effect="light">
									<i aria-hidden="true" class="icon el-icon-view"></i>
								</el-tooltip>
							</div>
							<div
								v-if="$permissions(['SP22106'])"
								style="color: #3f6af7;"
								@click=";(modalTitle = '编辑'), editButton(slot.row.uid)"
							>
								<!-- 1.4.5转校屏蔽 -->
								<!-- && slot.row.student_state == '未入学' -->
								<el-tooltip content="编辑" placement="bottom" effect="light">
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-iconoutlinesetting"></use>
									</svg>
								</el-tooltip>
							</div>
							<!-- 1.4.5转校屏蔽 -->
							<!-- <div v-if="
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && slot.row.student_state == '就读中') ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions(['SP22107']) && slot.row.student_state == '就读中')
              " style="color: #37c89c;" @click="promptTurn(slot.row.uid)">
								<el-tooltip content="转校" placement="bottom" effect="light">
									<svg
										class="icon"
										aria-hidden="true"
										style="width: 100%; height: 100%; outline: none; box-shadow: none;"
									>
										<use xlink:href="#icon-turn"></use>
									</svg>
								</el-tooltip>
							</div> -->
							<div
								v-if="$permissions(['SP22108'])"
								class="icon delete"
								style="color: #f13048;"
								@click="promptRemove(slot.row.uid)"
							>
								<!-- 1.4.5转校屏蔽 -->
								<!-- && slot.row.student_state == '未入学' -->
								<el-tooltip content="删除" placement="bottom" effect="light">
									<svg
										class="icon"
										aria-hidden="true"
										style="width: 100%; height: 100%; outline: none; box-shadow: none;"
									>
										<use xlink:href="#icon-deltred"></use>
									</svg>
								</el-tooltip>
							</div>
							<div style="color: #666666;" @click="resetPwd(slot.row.uid)" v-permission="'SP22105'">
								<el-tooltip content="重置" placement="bottom" effect="light">
									<i aria-hidden="true" class="icon el-icon-refresh-right"></i>
								</el-tooltip>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-page">
				<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
				<el-pagination
					class="pagination"
					background
					@size-change="
						$event => {
							;(pageSize = $event), refreshDataList()
						}
					"
					@current-change="
						$event => {
							;(currentPage = $event), getStudentList()
						}
					"
					:page-size="pageSize"
					:total="totalItems"
					:current-page.sync="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					layout="prev,pager,next,jumper,sizes"
					style="margin-top: 21px; margin-left: 10px;"
					:key="paginationKey"
				>
				</el-pagination>
			</div>
		</div>

		<!-- 批量创建 -->
		<batch-import-account ref="importDialog" :target="'class-student'" :id="info.id" />

		<el-dialog
			class="scope-dialog"
			:width="'540px'"
			:before-close="beforeNewClose"
			:close-on-click-modal="false"
			:visible="newVisible"
			@close="beforeNewClose"
			:destroy-on-close="true"
			:title="modalTitle"
		>
			<el-divider></el-divider>
			<el-form :model="model" :rules="vaRules" ref="newForm" label-width="95px">
				<el-form-item prop="realname" label="真实姓名">
					<InputTopTip v-model="model.realname" placeholder="真实姓名">
						<el-input v-model="model.realname" placeholder="" style="width: 100%;" size="medium" />
					</InputTopTip>
				</el-form-item>
				<el-form-item label="性别" prop="sex" style="margin-top: 25px;">
					<InputTopTip v-model="model.sex" placeholder="性别">
						<el-select v-model="model.sex" style="width: 100%;" placeholder="" size="small">
							<el-option v-for="d in sexArr" :key="d.val" :label="d.name" :value="d.val" />
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="班内序号" prop="number_in_class" style="margin-top: 25px;">
					<InputTopTip v-model="model.number_in_class" placeholder="班内序号">
						<el-input
							placeholder=""
							v-model="model.number_in_class"
							@input="e => (model.number_in_class = numberCheck(e))"
							style="width: 100%;"
							size="medium"
						/>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="学籍号" prop="serial" style="margin-top: 25px;">
					<InputTopTip v-model="model.serial" placeholder="学籍号">
						<el-input
							placeholder=""
							:maxlength="25"
							:minlength="5"
							v-model="model.serial"
							@input="e => (model.serial = validForbid(e))"
							style="width: 100%;"
							size="medium"
						/>
					</InputTopTip>
				</el-form-item>
			</el-form>
			<el-divider></el-divider>
			<div _flex="~ items-center justify-center" _m="y-20px">
				<el-button class="btn-close" @click="newVisible = false" _w="!80px" _h="!32px" style="line-height: 1px;"
					>取 消</el-button
				>
				<el-button class="btn-prim" type="primary" @click="confirm" _w="!80px" _h="!32px" style="line-height: 1px;"
					>确定</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { sexArr, studentStatus } from './const.js'
import { vaRules } from './rule.js'
import { throttle } from 'lodash'
import BatchImportAccount from '@/components/BatchImportAccount'
import { exportXLS } from '@/utils/job.js'
export default {
	components: {
		BatchImportAccount
	},
	data() {
		return {
			search: {
				name: '',
				fu_number_in_class: '',
				fb_state: ''
			},
			newVisible: false,
			info: {},
			dataList: [],
			currentPage: 1,
			pageSize: 10,
			totalItems: 0,
			model: {
				number_in_class: '',
				sex: '',
				realname: '',
				serial: ''
			},
			modalTitle: '',
			sexArr,
			studentStatus,
			vaRules,
			paginationKey: new Date().getTime(),
			multipleSelection: [],
			/** 页面是否不允许页面回退 */
			isNotAllowBack: history.state.notAllowBack == true
		}
	},
	methods: {
		numberCheck(num) {
			let checkNum = num.replace(/\D/g, '')
			if (num < 1) {
				checkNum = ''
			} else if (num >= 999999) {
				checkNum = 999999
			}
			return checkNum
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		async exportExcel(key, fileName) {
      const tiemstamp = new Date()
      let job = {
        job_id: tiemstamp.getTime(),
        created_at: tiemstamp,
        progress: 0,
        name: fileName,
        type: 'XLS',
      }
      let ids = this.multipleSelection.map(item => {
        return item.uid
      })
			this.$confirm(`是否要导出登录密码?`, '温馨提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(async () => {
          exportXLS(this, { ...job, msgType: key, prop: { has_password: true, ids } })
				})
				.catch(async action => {
					if (action === 'close') {
						return
					}
          exportXLS(this, { ...job, msgType: key, prop: { has_password: false, ids } })
				})
        .finally(() => {
          this.$store.state.job.isDot = true
        })
		},
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},
		async getEditlist(id) {
			const data = await this.$api.classgrade.editlist(id)
			this.info = data
		},
		refreshDataList() {
			this.currentPage = 1
			this.getStudentList()
		},
		resetList(formName) {
			this.$refs[formName].resetFields()
			this.refreshDataList()
		},
		confirm: throttle(function () {
			this.$refs['newForm'].validate(async valid => {
				if (valid) {
					await this.createStudent()
					this.$message.success('新建成功')
					this.beforeNewClose()
					this.getStudentList()
					const { id } = this.$route.query
					this.getEditlist(id)
				}
			})
		}),
		async createStudent() {
			const params = {
				school_id: this.info.school_id,
				number_in_class: this.model.number_in_class,
				class_grade_id: this.info.id,
				account: {
					serial: this.model.serial,
					realname: this.model.realname,
					sex: this.model.sex
				}
			}
			if (this.modalTitle == '新建') {
				await this.$api.student.create(params)
			} else {
				await this.$api.student.update(this.model.id, params)
			}
		},
		async editButton(id) {
			const data = await this.$api.student.showto(id)
			this.model = {
				number_in_class: data.number_in_class,
				sex: data.account.sex,
				realname: data.account.realname,
				serial: data.account.serial,
				id: id
			}
			this.newVisible = true
		},
		async getStudentList() {
			const params = {
				page: this.currentPage,
				page_size: this.pageSize,
				school_name: this.info.school_name,
				grade: this.info.grade_number,
				seq: this.info.seq,
				pathId: this.info.id,
				...this.search
			}
			this.$store.commit('setSearchParams', { key: this.$route.name, params })
			this.paginationKey = new Date().getTime()
			const { meta, data } = await this.$api.student.list(params)
			this.totalItems = meta.total
			this.dataList = data
		},
		music_typeFormat(row, column) {
			if (row.account.sex === 1) {
				return '男'
			} else if (row.account.sex === 2) {
				return '女'
			} else if (row.account.sex === 0) {
				return '未知'
			}
		},
		resetPwd(id) {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const data = await this.$api.teacher.ResetPwd({ ids: [id] })
				if (data.success === true) {
					this.refreshDataList()
					this.$message.success('重置密码成功，密码为：000000')
				}
			})
		},
		promptRemove(id) {
			this.$confirm('此操作将永久删除该学生以及附属数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.student.delete(id)
				this.$message.success('删除成功，请刷新数据')
				this.refreshDataList()
			})
		},
		promptTurn(id) {
			this.$confirm('是否对该学生进行转校操作？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.student.updateState(id)
				this.$message.success('操作成功，请刷新数据')
				this.refreshDataList()
			})
		},
		beforeNewClose() {
			this.$refs['newForm'].resetFields()
			this.model = {}
			this.newVisible = false
		}
	},
	async created() {
		// 沙雕竟然觉得不弹性布局更好 4
		// document.body.style['overflow-y'] = 'hidden'
		const { id } = this.$route.query
		await this.getEditlist(id)
		try {
			const { page, page_size, name, fu_number_in_class, pathId, fb_state } = this.$store.state.searchParams[
				this.$route.name
			]
			if (pathId == id) {
				this.search.name = name
				this.search.fu_number_in_class = fu_number_in_class
				this.search.fb_state = fb_state
				this.currentPage = page
				this.pageSize = page_size
				this.getStudentList()
			} else {
				this.getStudentList()
			}
		} catch (err) {
			console.log('正常~')
			this.getStudentList()
		}
	},
	destroyed() {
		document.body.style['overflow-y'] = 'auto'
	}
}
</script>

<style lang="scss" scoped>
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagetotal {
	width: 200px;
	margin-left: 10px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
</style>
